<template>
	<div class="flex flex-col bg-gradient-to-tr from-primary to-primary-dark px-4 pb-16 pt-12">
		<div class="flex w-full max-w-screen-xl flex-col self-center">
			<div class="mb-6 flex items-center">
				<span class="text-white flex-grow text-2xl font-bold">
					{{ $t("article_categories") }}
				</span>
			</div>
			<div
				class="flex w-full flex-col overflow-hidden rounded-xl bg-gradient-to-t from-slate-50 to-white p-4 shadow-inner"
			>
				<Swiper
					v-if="categories?.length"
					class="w-full !overflow-visible"
					slides-per-view="auto"
					:space-between="16"
				>
					<SwiperSlide
						v-for="category in sortedCategories"
						:key="category.id"
						class="!flex max-w-[375px] flex-grow flex-col"
					>
						<NuxtLink :to="$routeUrl.BlogCategoryUrl(category.id)" class="flex flex-grow flex-col">
							<BlogCategoryCard :category="category" class="flex-grow" />
						</NuxtLink>
					</SwiperSlide>
				</Swiper>
				<div v-if="!categories?.length" class="flex flex-col py-2">
					<BaseEmptyBox class="w-full max-w-lg self-center" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Category } from "~/models/category"

const props = defineProps<{
	categories?: Category[]
}>()

const sortedCategories = computed(
	() => props.categories?.slice?.()?.sort?.((a, b) => b.post_count - a.post_count) || []
)
</script>
